import React from 'react';
import { content } from '../data/content';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  return (
    <footer id="contact" className="bg-white pt-20 pb-12 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 mb-16">
          <div>
            <h2 className="text-4xl font-serif font-bold text-slate-900 mb-6">Let's Connect</h2>
            <p className="text-lg text-slate-600 mb-8 max-w-md">
              Engage with me for opportunities in banking transformation, PMO leadership, or advisory roles.
            </p>
            <div className="flex flex-col gap-4">
              <a href={`mailto:${content.contact.email}`} className="flex items-center gap-3 text-slate-800 hover:text-slate-600 transition-colors">
                <SafeIcon icon={FiIcons.FiMail} className="text-xl" />
                <span className="font-medium">{content.contact.email}</span>
              </a>
              <a href={content.contact.linkedin} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-slate-800 hover:text-slate-600 transition-colors">
                <SafeIcon icon={FiIcons.FiLinkedin} className="text-xl" />
                <span className="font-medium">/in/maries-villarosa-pmp</span>
              </a>
              <div className="flex items-center gap-3 text-slate-800">
                <SafeIcon icon={FiIcons.FiMapPin} className="text-xl" />
                <span className="font-medium">{content.contact.location}</span>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 p-8 rounded-2xl">
            <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Name</label>
                <input type="text" className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-900 bg-white" placeholder="Jane Doe" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                <input type="email" className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-900 bg-white" placeholder="jane@company.com" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Message</label>
                <textarea rows="4" className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-900 bg-white" placeholder="Project details..."></textarea>
              </div>
              <button type="submit" className="w-full py-3 bg-slate-900 text-white font-medium rounded-lg hover:bg-slate-800 transition-colors">
                Send Message
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">© {new Date().getFullYear()} Maries Villarosa. All rights reserved.</p>
          <div className="flex gap-6 text-slate-400 text-sm">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Contact;